import MoveLogoWhite from './MoveLogoWhite.png'
import './moveTeamImg.css'

const moveTeamImgWhite= <img className='panel-moveLogo' src={MoveLogoWhite}/>;

export default moveTeamImgWhite;